import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../features/userSlice";
import { fetchAppCodes } from "../../../views/Admin/AppCodes/appCodesApi";
import { formatDateTime } from "../../Fleet/fleetFormat";
import WidgetFrame, { WidgetEmpty, WidgetStat } from "./WidgetFrame";

// Node Mobile download codes at a glance (Admin / IT): how many are left to
// hand out, how many went out, how many of those links were opened, and the
// most recent send.
const AppCodesWidget = () => {
  const user = useSelector(selectUser);
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!user?.id) return;
    fetchAppCodes(user.id)
      .then(setData)
      .catch(() => setFailed(true));
  }, [user?.id]);

  if (!data) {
    return (
      <WidgetFrame title="Mobile App Codes" to="/admin/app-codes">
        <WidgetEmpty>{failed ? "Couldn't load app codes." : "Loading codes…"}</WidgetEmpty>
      </WidgetFrame>
    );
  }

  const last = data.sends.find((s) => s.ok);

  return (
    <WidgetFrame title="Mobile App Codes" to="/admin/app-codes">
      {data.counts.total === 0 ? (
        <WidgetEmpty>No codes imported yet.</WidgetEmpty>
      ) : (
        <>
          <div className="grid grid-cols-3 gap-2">
            <WidgetStat value={data.counts.available} label="Left" />
            <WidgetStat value={data.counts.sent} label="Sent" />
            <WidgetStat value={data.counts.opened} label="Opened" />
          </div>
          {last && (
            <p className="app-muted mt-2 truncate text-xs">
              Last sent to {last.display} · {formatDateTime(last.at)}
            </p>
          )}
        </>
      )}
    </WidgetFrame>
  );
};

export default AppCodesWidget;
